<template>
	<section class="Search">
		<h2>フリーワード検索：</h2>
		<div class="wrapper">
			<div class="search">
				<input type="text" v-model="keyword" />
				<i class="icon-search"></i>
			</div>
			<div class="results">
				<A v-for="result in filtered" class="result" :key="`${result}`" v-html="getResultHTML(result)" @click="onSelectSearch(result)"></A>
			</div>
		</div>
		<Button @click="onClickSearch" :disabled="!(this.selectedKeyword && this.selectedKeyword === this.keyword)">検索する</Button>
	</section>
</template>

<script>
	export default {
		props: ['search'],
		data() {
			return {
				keyword: '',
				selectedKeyword: ''
			};
		},
		computed: {
			filtered() {
				return this.search.entries.filter(e => e.toLowerCase().includes(this.keyword.toLowerCase()) && e !== this.keyword);
			}
		},
		methods: {
			getResultHTML(result) {
				return result.replace(new RegExp(this.keyword, 'ig'), e => `<strong>${e}</strong>`);
			},

			onSelectSearch(result) {
				this.keyword = result;
				this.selectedKeyword = result;
			},

			onClickSearch() {
				this.$emit('search', this.selectedKeyword);
			}
		}
	};
</script>

<style scoped lang="scss">
	.Search {
		padding: 1rem 1.6rem;

		& > * {
			&:not(:first-child) {
				margin-top: 1rem;
			}
		}

		h2 {
			font-size: 1.6rem;
			font-weight: normal;
		}

		.wrapper {
			border: solid 1px rgba(0, 0, 0, 0.1);
			border-radius: 0.5rem;

			.search {
				width: 100%;
				position: relative;

				input {
					width: 100%;
					padding: 1rem;
					color: var(--clrTheme);
					outline: none;
					font-size: inherit;
					border: none;
					background-color: transparent;
					margin-right: 8rem;
				}

				i {
					position: absolute;
					top: 50%;
					right: 1rem;
					transform: translateY(-50%);
				}
			}

			.results {
				border-top: none;
				position: relative;
				overflow: hidden;
				overflow-y: auto;
				max-height: 20rem;

				&:not(:empty) {
					border-top: solid 1px rgba(0, 0, 0, 0.1);
				}

				.result {
					padding: 1rem;
					width: 100%;
					word-break: break-all;
					outline: none;

					&:hover,
					&:focus {
						background-color: var(--clrTheme);
						color: white;

						/deep/ strong {
							color: inherit;
						}
					}

					&:not(:first-of-type) {
						border-top: solid 1px rgba(0, 0, 0, 0.1);
					}

					/deep/ strong {
						color: var(--clrTheme);
					}
				}
			}
		}

		.Button {
			width: 100%;
		}
	}
</style>
